import { render, staticRenderFns } from "./projectItem.vue?vue&type=template&id=21673216&scoped=true"
import script from "./projectItem.vue?vue&type=script&lang=js"
export * from "./projectItem.vue?vue&type=script&lang=js"
import style0 from "./projectItem.vue?vue&type=style&index=0&id=21673216&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21673216",
  null
  
)

export default component.exports